export default __webpack_public_path__ + "static/media/EM0780.34I-21942_-14965_0.f27f35c2.jpg";